import _regeneratorRuntime from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Alert from '@/components/shared/Alert';
import Panel from '@/components/shared/Panel';
import FilterEditForm from '@/components/filter-management/FilterEditForm';
import ScrollAnimatorService from '@/services/ScrollAnimatorService';
import { SearchFilter } from '@/services/ResourceService';
import _ from 'lodash';
export default {
  name: 'FilterEditSubPage',
  components: {
    Alert: Alert,
    FilterEditForm: FilterEditForm,
    Panel: Panel
  },
  props: {
    isCreation: {
      type: Boolean,
      required: true
    },
    filterId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      isLoading: true,
      isSubmitting: false,
      successfullySaved: false,
      validationErrorOccurred: false,
      serverErrorOccurred: false,
      rawFilterData: null,
      editedFilterData: {},
      validationErrors: []
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.isLoading = true;
            _context.prev = 1;
            if (!_this.filterId) {
              _context.next = 5;
              break;
            }
            _context.next = 5;
            return _this.loadSearchFilter(_this.filterId);
          case 5:
            _this.isLoading = false;
            _context.next = 12;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            _this.isLoading = false;
            _this.serverErrorOccurred = true;
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }))();
  },
  methods: {
    loadSearchFilter: function loadSearchFilter(filterId) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return SearchFilter.getSearchFilter(_this2.$store.state.general.selectedUser.id, filterId);
            case 2:
              response = _context2.sent;
              _this2.rawFilterData = response.data;
              _this2.editedFilterData = _.cloneDeep(_this2.rawFilterData);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    onSubmissionSuccess: function onSubmissionSuccess() {
      var _this3 = this;
      if (this.isCreation) {
        setTimeout(function () {
          _this3.$router.push({
            name: 'filter-management'
          });
        }, 1000);
      }
      this.isSubmitting = false;
      this.successfullySaved = true;
      ScrollAnimatorService.scrollToTopOfElement(this.$el);
    },
    onSubmissionError: function onSubmissionError(error) {
      var data = error.response.data;
      var errorCode = data.status.code;
      var payload = data.payload;
      if (errorCode === 400 && (payload === null || payload === void 0 ? void 0 : payload.length) > 0) {
        this.validationErrorOccurred = true;
        this.validationErrors = payload;
      } else {
        this.serverErrorOccurred = true;
      }
      this.isSubmitting = false;
      ScrollAnimatorService.scrollToTopOfElement(this.$el);
    },
    submitForm: function submitForm() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var searchFilterDTO;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isSubmitting = true;
              _this4.validationErrorOccurred = false;
              _this4.serverErrorOccurred = false;
              _this4.successfullySaved = false;
              _this4.validationErrors = null;
              searchFilterDTO = {
                id: _this4.filterId,
                name: _this4.editedFilterData.name,
                locationIds: _this4.editedFilterData.locationIds,
                locationGroupIds: _this4.editedFilterData.locationGroupIds
              };
              if (!_this4.filterId) {
                SearchFilter.createNewSearchFilter(_this4.$store.state.general.user.id, searchFilterDTO).then(_this4.onSubmissionSuccess, _this4.onSubmissionError);
              } else {
                SearchFilter.updateSearchFilter(_this4.$store.state.general.user.id, _this4.filterId, searchFilterDTO).then(_this4.onSubmissionSuccess, _this4.onSubmissionError);
              }
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};